import * as React from "react";
import * as ReactDOM from "react-dom";
import { DataGridMUI } from "../ui/DataGridMUI";
import { variables } from "../Variables";

import axios from 'axios';
import { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";

import {
    GridRowModes,
    DataGrid,
    GridActionsCellItem,
    GridRowEditStopReasons,
} from '@mui/x-data-grid';

import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';

export const Agents = ({ showMessage }) => {

    const [whiseAgents, setWhiseAgents] = useState([]);
    const [selectAgentFromDropDown, setSelectAgentFromDropDown] = useState("");
    const [selectAgentLanguage, setSelectAgentLanguage] = useState("");
    const [selectAgentValidation, setSelectAgentValidation] = useState(false);
    const [selectAgentLanguageValidation, setSelectAgentLanguageValidation] = useState(false);
    
    const [rowModesModel, setRowModesModel] = React.useState({});
    const [allAgentList, setAllAgentList] = useState([]);
    const [pageNumberDataGrid, setPageNumberDataGrid] = useState(0);
    const [pageSizeDataGrid, setPageSizeDataGrid] = useState(25);
    const [totalRecordDataGrid, setTotalRecordDataGrid] = useState(0);
    const [isLoadingDataGrid, setIsLoadingDataGrid] = useState(true);

    const user = useSelector(state => state.user.user);
    const reduxClientToken = useSelector(state => state.whiseClientToken.whiseClientToken);
    const reduxLanguageTranslations = useSelector(state => state.selectedLanguageTranslations.selectedLanguageTranslations);
    const clientId = user.user.clientId;

    const getAllAgentFromDB = async () => {
        setIsLoadingDataGrid(true);
        try {
            const url = `${variables.API_URL}Estate/GetAgents?clientId=${clientId}&pageNumber=${pageNumberDataGrid + 1}&pageSize=${pageSizeDataGrid}`;

            const config = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            }
            const response = await axios.get(url, config);
            if (response.data) {
               // console.log(response.data);
                if (response.data.data.length > 0) {
                    const agentList = response.data.data.map((item, index) => {

                        return {
                            ...item,
                            id: index + 1,
                        }
                    });

                    setAllAgentList(agentList);
                    setTotalRecordDataGrid(response.data.totalRecords);
                   // setPageSizeDataGrid(response.data.pageSize);
                   //setPageNumberDataGrid(response.data.pageNumber);
                   //setIsLoadingDataGrid(false);
                }
                setIsLoadingDataGrid(false);

            }
        } catch (error) {
            console.log(error);
            setIsLoadingDataGrid(false);
        }
    }

    const getWhiseAgents = async () => {
        try {
            let url = "https://api.whise.eu/v1/admin/representatives/list";
            const config = {
                headers: {
                    'Authorization': `Bearer ${reduxClientToken}`,
                    'Content-Type': 'application/json'
                },
            };

            const response = await axios.post(url, {}, config);
            if (response.data.representatives) {
               // console.log(response.data.representatives);
                setWhiseAgents(response.data.representatives);
            }
        } catch (error) {
            console.log(error);
        }
        
    }

    const onChangeAgentSelectFromList = (event) => {
       // console.log(event.target.value);
        setSelectAgentFromDropDown(event.target.value);
        setSelectAgentValidation(false);
    }

    const onChangeSelectAgentLanguage = (event) => {
        setSelectAgentLanguage(event.target.value);
        setSelectAgentLanguageValidation(false);
    }

    const addNewAgentInLocalDB = async (updateRowObj) => {
        setIsLoadingDataGrid(true);
        try {
            const url = `${variables.API_URL}Estate/UpsertAgent`;

            const config = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            }

            if (selectAgentFromDropDown == "" && updateRowObj == undefined) {
                setSelectAgentValidation(true);
                setIsLoadingDataGrid(false);
                return;
            }

            if (selectAgentLanguage == "" && updateRowObj == undefined) {
                setSelectAgentLanguageValidation(true);
                setIsLoadingDataGrid(false);
                return;
            }

            let body;

            if (updateRowObj == undefined) {
                const filterAgent = whiseAgents.filter(item => item.id == selectAgentFromDropDown);
                //console.log(filterAgent);
                body = {
                    "clientId": +clientId,
                    "externalId": filterAgent[0].id,
                    "firstName": filterAgent[0].firstName,
                    "directLine": filterAgent[0]?.directLine || "",
                    "name": filterAgent[0].name,
                    "email": filterAgent[0].email,
                    "mobile": filterAgent[0]?.mobile || "",
                    "language": selectAgentLanguage,
                    "officeId": filterAgent[0].officeId
                }
            } else {
                body = updateRowObj;
            }

           // console.log(body);

            const response = await axios.post(url, body, config);
            if (response.data) {
                //console.log(response.data);
                getAllAgentFromDB();
                resetAllField();
            }
        } catch (error) {
            console.log(error);
            setIsLoadingDataGrid(false);
        }
    }

    const resetAllField = () => {
        setSelectAgentFromDropDown("");
        setSelectAgentLanguage("");
    }

    useEffect(() => {
        if (reduxClientToken) {
            getWhiseAgents();
        }
    }, [reduxClientToken]);

    useEffect(() => {
        if (reduxClientToken && whiseAgents.length > 0) {
            getAllAgentFromDB();
        }
    }, [reduxClientToken, pageNumberDataGrid, pageSizeDataGrid, whiseAgents]);

    const handleSaveClick = (id) => () => {
        setRowModesModel({ [id]: { mode: GridRowModes.View } });
    };

    const handleEditClick = (id) => () => {
        if (Object.keys(rowModesModel).length == 0) {
            setRowModesModel({ [id]: { mode: GridRowModes.Edit } });
        }
    };

    const handleCancelClick = (id) => () => {
        setRowModesModel({ [id]: { mode: GridRowModes.View, ignoreModifications: true } });
    };

    const processRowUpdate = async (newRow) => {
        try {
            const body = {
                "clientId": +clientId,
                "externalId": newRow.externalId,
                "firstName": newRow.firstName,
                "directLine": newRow.directLine || "",
                "name": newRow.name,
                "email": newRow.email,
                "mobile": newRow.mobile || "",
                "language": newRow.language,
                "officeId": newRow.officeId
            };

            addNewAgentInLocalDB(body);
            console.log("Language updated successfully")
            return newRow;
        } catch (error) {
            console.log("Update failed");
            throw error;
        }
    };

    let columns = [
        {
            field: 'externalId',
            headerName: reduxLanguageTranslations != null ? reduxLanguageTranslations["externalIdLabel"] : 'External Id',
            flex: 1,
        },
        {
            field: 'firstName',
            headerName: reduxLanguageTranslations != null ? reduxLanguageTranslations["firstNameLabel"] : 'First Name',
            flex: 1,
        },
        {
            field: 'name',
            headerName: reduxLanguageTranslations != null ? reduxLanguageTranslations["inviteeModalNamePlaceHolder"] : 'Name',
            flex: 1,
        },
        {
            field: 'email',
            headerName: reduxLanguageTranslations != null ? reduxLanguageTranslations["email"] : 'Email',
            flex: 1,
        },
        {
            field: 'mobile',
            headerName: reduxLanguageTranslations != null ? reduxLanguageTranslations["mobile"] : 'Mobile',
            flex: 1,
        },
        {
            field: 'language',
            headerName: reduxLanguageTranslations != null ? reduxLanguageTranslations["languageLabel"] : 'Language',
            flex: 1,
            editable: true,
            type: 'singleSelect',
            valueOptions: ['fr-BE', 'en-GB', 'nl-BE'],
        },
        {
            field: 'officeId',
            headerName: reduxLanguageTranslations != null ? reduxLanguageTranslations["settingsPageOfficeIdLbl"] : 'Office Id',
            flex: 1,
        },
        {
            field: 'directLine', 
            headerName: reduxLanguageTranslations != null ? reduxLanguageTranslations["directLine"] : 'Direct Line',
            flex: 1,
        },
        {
            field: 'actions',
            type: 'actions',
            headerName: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridActionsLabelHeading"] : 'Actions',
            flex: 1,
            cellClassName: 'actions',
            getActions: ({ id }) => {
                //alert("getActions");
                const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

                if (isInEditMode) {
                    return [
                        <GridActionsCellItem
                            icon={<SaveIcon />}
                            label="Save"
                            sx={{
                                color: 'primary.main',
                            }}
                           onClick={handleSaveClick(id)}
                        />,
                        <GridActionsCellItem
                            icon={<CancelIcon />}
                            label="Cancel"
                            className="textPrimary"
                            onClick={handleCancelClick(id)}
                            color="inherit"
                        />,
                    ];
                }
                else {
                    return [
                        <GridActionsCellItem
                            icon={<EditIcon />}
                            label="Edit"
                            className="textPrimary"
                            onClick={handleEditClick(id)}
                            color="inherit"
                        />,
                    ];
                }
            },
        }
    ]

    return (
        <>
            <div className="px-4">
                <div className="agentDataGrid-container row mb-4">
                    <div className="col-12">
                        <DataGridMUI
                            columns={columns}
                            rows={allAgentList}
                            isLoading={isLoadingDataGrid}
                            rowModesModel={rowModesModel}
                            onRowModesModelChange={setRowModesModel}
                            processRowUpdate={processRowUpdate}
                            pageNumber={pageNumberDataGrid}
                            setPageNumber={setPageNumberDataGrid}
                            pageSize={pageSizeDataGrid}
                            setPageSize={setPageSizeDataGrid}
                            totalRecord={totalRecordDataGrid}
                        />
                    </div>
                </div>
                <h6 className="mb-2">{reduxLanguageTranslations ? reduxLanguageTranslations["addNewUser"] : "Add a new user"}</h6>
                <div className="row align-items-center mb-4">
                    <div className="col-sm-6 col-md-6 col-lg-3">
                        <select className={`form-select ${selectAgentValidation ? "border-red" : ""}`} id="visitToRentBefore" value={selectAgentFromDropDown}
                            onChange={onChangeAgentSelectFromList}>
                            <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterDropdownAgentSelect"] : "Select Agent"}</option>
                            {
                                whiseAgents.length > 0 ? whiseAgents.map((item, index) => {
                                    return (
                                        <option value={item.id} key={index}>{item.firstName} {item.name}</option>
                                    )
                                }) :
                                    <option>{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterDropdownAgentSelect"] : "Select Agent"}</option>
                            }
                        </select>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-3">
                        <select className={`form-select ${selectAgentLanguageValidation ? "border-red" : ""}`} id="selectAgentLanguage" value={selectAgentLanguage}
                            onChange={onChangeSelectAgentLanguage}>
                            <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["selectLanguage"] : "Select Language"}</option>
                            <option value="en-GB">en-GB</option>
                            <option value="fr-BE">fr-BE</option>
                            <option value="nl-BE">nl-BE</option>
                        </select>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-3">
                        <button className="site-btn" onClick={() => addNewAgentInLocalDB()}>{reduxLanguageTranslations ? reduxLanguageTranslations["addLabel"] : "Add"}</button>
                    </div>
                </div>
            </div>
        </>
    )
}